import { Button } from "@/components/ui/Button";

export function LogoutNotice({
  countdown,
  onContinue,
}: {
  countdown: number;
  onContinue: () => void;
}) {
  const progress = Math.max(0, Math.min(100, ((6 - countdown) / 6) * 100));

  return (
    <div className="mb-2 space-y-5 text-center">
      <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-accent-soft text-accent">
        <svg viewBox="0 0 24 24" className="h-8 w-8" aria-hidden fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" strokeLinecap="round" strokeLinejoin="round" />
          <polyline points="16 17 21 12 16 7" strokeLinecap="round" strokeLinejoin="round" />
          <line x1="21" y1="12" x2="9" y2="12" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>

      <div className="space-y-2">
        <h2 className="text-lg font-semibold text-label">Abmeldung erfolgreich</h2>
        <p className="text-sm leading-relaxed text-label-secondary">
          Sie wurden sicher abgemeldet. Aus Sicherheitsgründen empfehlen wir, offene
          Browserfenster zu schließen, wenn Sie den Arbeitsplatz verlassen.
        </p>
      </div>

      <div className="flex flex-col items-center gap-3">
        <div className="relative flex h-20 w-20 items-center justify-center">
          <svg className="absolute inset-0 h-20 w-20 -rotate-90" viewBox="0 0 80 80" aria-hidden>
            <circle
              cx="40"
              cy="40"
              r="34"
              fill="none"
              stroke="currentColor"
              strokeWidth="6"
              className="text-fill-tertiary"
            />
            <circle
              cx="40"
              cy="40"
              r="34"
              fill="none"
              stroke="currentColor"
              strokeWidth="6"
              strokeLinecap="round"
              className="text-accent transition-all duration-1000 ease-linear"
              strokeDasharray={`${2 * Math.PI * 34}`}
              strokeDashoffset={`${2 * Math.PI * 34 * (1 - progress / 100)}`}
            />
          </svg>
          <span className="text-2xl font-bold tabular-nums text-label">{countdown}</span>
        </div>
        <p className="text-xs text-label-tertiary">
          Weiterleitung zur Anmeldung in {countdown} Sekunde{countdown === 1 ? "" : "n"} …
        </p>
      </div>

      <Button type="button" className="w-full" size="lg" onClick={onContinue}>
        Jetzt anmelden
      </Button>
    </div>
  );
}
